import { defineComponent } from 'vue';
export default defineComponent({
    name: 'list-item',
    props: {
        item: {
            type: Object,
            default: ({}),
        },
    },
});
